(function () {
	'use strict';

	/*
	 DisplayFeaturedProductsController
	-------------------------------------------------------------------------- */

	angular
		.module('PublicApp.display.featured.products', [])
		.controller('DisplayFeaturedProductsController', [
			'$scope',
			'__DataStore',
			'appServices',
			'__Utils',
			DisplayFeaturedProductsController
		]);

	/**
	 * DisplayFeaturedProductsController for displau products application
	 *
	 * @inject $scope
	 * @inject __DataStore
	 * @inject appServices
	 * @inject __Utils
	 * 
	 * @return void
	 *-------------------------------------------------------- */

	function DisplayFeaturedProductsController($scope, __DataStore, appServices, __Utils) {

		var scope = this;
		scope.pageData = {};
		scope.pageStatus = false;
		scope.products = [];

		// inject breadcrumb service
		appServices.updateBreadcrumbs([
			{
				items: '',
				last_item: __globals.getJSString('featured_products')
			}
		], $scope);

        /**
        * display all active featured products list
        *
        * @return void
        *---------------------------------------------------------------- */

		scope.getFeaturedProducts = function (url) {
			var requestURL = url ? url : 'display.featured.products.list';

			// send http request to server
			__DataStore.fetch(requestURL)
				.success(function (responseData) {

					appServices.processResponse(
						responseData,
						null,
						function (reactionCode) {

							var requestData = responseData.data;

							_.forEach(requestData.data, function (product, key) {

								scope.products.push(product);

							});

							scope.pageData = {
								"total": requestData.total,
								"per_page": requestData.per_page,
								"current_page": requestData.current_page,
								"last_page": requestData.last_page,
								"next_page_url": requestData.next_page_url,
								"prev_page_url": requestData.prev_page_url,
								"from": requestData.from,
								"to": requestData.to
							};

							scope.pageStatus = true;
							scope.mediaURL = requestData.product_assets;
							scope.totalProductCount = requestData.count;

						});
				});
		};
		scope.getFeaturedProducts();

		$(window).scroll(getFeaturedNewProducts);

	    /**
	    * get on scroll products list
	    *
	    * @return void
	    *---------------------------------------------------------------- */

		function getFeaturedNewProducts() {

			if (scope.pageData.current_page < scope.pageData.last_page
				&& scope.pageStatus
				&& $(window).scrollTop() + 1 >= $(document).height() - $(window).height()) {

				scope.pageData.current_page += 1;

				var url = __Utils.apiURL('display.featured.products.list') + '?page='
					+ scope.pageData.current_page;

				scope.getFeaturedProducts(url);
			}

		};

	};

})();